module.exports = __webpack_public_path__ + "static/fiji1-1024x908-c1798989001128d8a149ba7cc1f51562.png";